/**
 * Pure utility functions for the PortfolioMetricChart shared component.
 * Kept separate from the React component so tests can import them
 * without pulling in the full component tree.
 */

/**
 * Compute YTD region sums from a normalized monthly series.
 *
 * @param {Array<{ukNative?: number, frNative?: number}>} monthlySeries
 * @returns {{ uk: number, fr: number }}
 */
export function computeYtdSums(monthlySeries) {
  if (!monthlySeries?.length) return { uk: 0, fr: 0 };
  const uk = monthlySeries.reduce((s, m) => s + (m.ukNative || 0), 0);
  const fr = monthlySeries.reduce((s, m) => s + (m.frNative || 0), 0);
  return { uk, fr };
}
